import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubtasksProcessed } from '../../models/SubtasksProcessed';

interface SubtasksProcessedState {
  processedSubtasks: SubtasksProcessed[];
  loading: boolean;
  error: string | null;
}

const initialState: SubtasksProcessedState = {
  processedSubtasks: [],
  loading: false,
  error: null,
};

const subtasksProcessedSlice = createSlice({
  name: 'subtasksProcessed',
  initialState,
  reducers: {
    setProcessedRollen: (state, action: PayloadAction<SubtasksProcessed[]>) => {
      state.processedSubtasks = action.payload;
    },
    clearProcessedRollen: state => {
      state.processedSubtasks = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setProcessedRollen, clearProcessedRollen, setLoading, setError } =
  subtasksProcessedSlice.actions;

export default subtasksProcessedSlice.reducer;
